module.exports = __webpack_public_path__ + "img/doors-right.ceab800d.svg";